module.exports = __webpack_public_path__ + "img/gift-2.eaab6db0.svg";